<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  list(checklistId) {
    return axios.get(`checklists/${checklistId}/list`, AS.getDefaultHeaders());
  },
  createChecklist(applicationTypeId, typologyId) {
    return axios.post('checklists', {
      checklist: {
        application_type_id: applicationTypeId,
        typology_id: typologyId,
      },
    },
    AS.getDefaultHeaders());
  },
  addDocumentType(checklistId, documentTypeIds) {
    return axios.post(`checklists/${checklistId}/add_document_type`,
      {
        checklist: {
          document_type_ids: documentTypeIds,
        },
      },
      AS.getDefaultHeaders());
  },
  removeDocumentType(checklistId, documentTypeId) {
    return axios.delete(`checklists/${checklistId}/document_type/${documentTypeId}`, AS.getDefaultHeaders());
  },
  sortDocumentType(list, id) {
    return axios.put(`checklists/${id}/drag_and_drop`, {ids: list}, AS.getDefaultHeaders());
  },
};
</script>
